import Link from "next/link";
import React from "react";
import { useRouter } from "next/router";

const Tags = ({ product }) => {
  const router = useRouter();
  return (
    <>
      {product.tag.length !== 0 && (
        <div className="flex flex-wrap">
          {(product?.tag).map((t, i) => (
            <span
              key={i + 1}
              className="cursor-pointer bg-gray-5000 mr-2 border-0 text-gray-6000 rounded-full inline-flex items-center justify-center px-3 py-1 text-xs font-semibold font-serif mt-2"
            >
              <div
                onClick={() => {
                  router.push(`/relatedProduct/${t}`);
                }}
              >
                {t}
              </div>
            </span>
          ))}
        </div>
      )}
    </>
  );
};

export default Tags;
